export default function onEnter(callback) {
  return (e) => {
    if (e.key === 'Enter') {
      callback(e);
    }
  };
}
